// extracted by mini-css-extract-plugin
export default {"image-wrapper":"image-wrapper___OaqPi","image-ele":"image-ele___hY5hX"};